import { css } from "lit";

/* Custom trigger styles for Mike Torchia (agent id 0762a5c3-4e48-4103-90e7-18974a39dd96) */
export const customUserMikeTorchiaStyles = css`
  .hollo-agent-mike-torchia {
    /* Red -> Black -> Grey gradient */
    --hollo-trigger-bg: linear-gradient(
      to right,
      #b91c1c 0%,
      #18181b 50%,
      #6b7280 100%
    );
    --hollo-trigger-shadow: rgba(185, 28, 28, 0.45);
  }

  /* Remove default focus ring (kills the yellow outline on red side), keep original white border */
  .hollo-agent-mike-torchia .hollo-trigger-gradient-minimalist:focus,
  .hollo-agent-mike-torchia .hollo-trigger-gradient-minimalist:focus-visible {
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }
`;
